module.exports = __webpack_public_path__ + "media/images/sp/specials/common/benefit/benefit_studio_free-e1af46f9088cedc4cf8242c343ece91d.jpg";